import styled from 'styled-components';
import { minBp } from 'src/lib/theme';

export const Wrap = styled.div`
  display: flex;
  padding: 18px 0;
  border-bottom: 1px solid #e0e0e0;
  position: relative;

  @media ${minBp('tabletLarge')} {
    display: inline-flex;
    align-items: center;
    margin: 2px 0;
    padding: 0;
    border: 0;

    &:not(:last-of-type) {
      margin-right: 15px;
    }
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    flex-direction: row-reverse;
  }
`;

export const Label = styled.label`
  color: #000;
  display: block;
  position: relative;
  padding-left: 24px;
  font-weight: 300;
  font-size: 14px;
  z-index: 9;
  cursor: pointer;

  @media ${minBp('tabletLarge')} {
    padding-top: 2px;
    margin: 2px 0;
  }

  ${({ isWhite }) =>
    isWhite &&
    `
    @media ${minBp('tabletLarge')} {
      color: #fff;
    }
  `}
`;

export const Input = styled.input`
  position: absolute;
  visibility: hidden;
`;

export const Check = styled.div`
  display: block;
  position: absolute;
  border: 1px solid #000;
  border-radius: 50%;
  height: 15px;
  width: 15px;
  z-index: 5;
  transition: border 0.25s linear;

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    top: 5px;
  }

  &:before {
    display: block;
    position: absolute;
    content: '';
    border-radius: 100%;
    height: 9px;
    width: 9px;
    top: 2px;
    left: 2px;
    margin: auto;
  }

  ${Input}:checked ~ & {
    background-color: #fff;

    &:before {
      background-color: #000;
    }
  }

  ${({ isWhite }) =>
    isWhite &&
    `
    @media ${minBp('tabletLarge')} {
      border: 1px solid #fff;
    }
    
    ${Input}:checked ~ & {
      background-color: #000;

      &:before {
        background-color: #fff;
      }
    }
  `}
`;
